// A aba de tarefas da ficha 360. (#880)

import { type ReactNode } from 'react';
import type { Cliente360, TarefaDo360 } from '@cliqcrm/contracts';
import { Defasado, Vazio } from '@/shared/ui/estados/estados';
import { prazoEmPalavras } from '@/entities/comercial/tarefa';
import { Chip, ListaLinha, Tabela } from '@/shared/ui';

export function PainelDeTarefas({ lista }: { lista: Cliente360['tarefas'] }): ReactNode {
  if (lista.itens.length === 0) {
    return (
      <Vazio
        titulo="Nenhuma tarefa aberta"
        porque="Nada pendente com este cliente. Criar uma é o que garante que alguém volte a falar com ele."
      />
    );
  }

  const prazoDe = (t: TarefaDo360): ReactNode => {
    const prazo = prazoEmPalavras(t.prazo_em);
    if (!prazo) return '—';
    // "prazo passou" é FATO. "Atrasada" é veredito, e depende do horário de
    // atendimento da revenda — a tela não tem essa regra.
    return <span className={prazo.passou ? 'c360__prazo--passou' : undefined}>{prazo.texto}</span>;
  };

  return (
    <>
      {lista.frescor.stale && (
        <Defasado projetadoEm={lista.frescor.projetado_em} origem="Esta lista" />
      )}

      <div className="c360__so-mouse">
        <Tabela
          rotulo="Tarefas deste cliente"
          colunas={[
            { chave: 'titulo', rotulo: 'Tarefa' },
            { chave: 'prazo', rotulo: 'Prazo' },
            { chave: 'status', rotulo: 'Situação' },
          ]}
          chaveDe={(_, i) => lista.itens[i]!.referencia_externa}
          linhas={lista.itens.map((t) => ({
            titulo: t.titulo ?? 'Sem título',
            prazo: prazoDe(t),
            status: t.status ? <Chip>{t.status}</Chip> : '—',
          }))}
        />
      </div>

      <ul className="c360__lista c360__so-cel">
        {lista.itens.map((t) => (
          <ListaLinha
            key={t.referencia_externa}
            densa
            nome={t.titulo ?? 'Sem título'}
            meta={
              <span className="c360__lista-meta">
                {t.status && <Chip>{t.status}</Chip>}
                {prazoDe(t)}
              </span>
            }
          />
        ))}
      </ul>
    </>
  );
}
